module.exports = __webpack_public_path__ + "img/undraw_project_team_lc5a.6ad60d0b.svg";